const state = {
    auth: {
        id: null,
        slug: null,
        roles: [ 'visitor' ]
    }
}

export default state